import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.15312 2.76945C6.9125 2.1882 6.27812 1.87883 5.67188 2.04445L2.92188 2.79445C2.37813 2.94445 2 3.4382 2 4.0007C2 11.732 8.26875 18.0007 16 18.0007C16.5625 18.0007 17.0563 17.6226 17.2063 17.0788L17.9563 14.3288C18.1219 13.7226 17.8125 13.0882 17.2312 12.8476L14.2312 11.5976C13.7219 11.3851 13.1313 11.532 12.7844 11.9601L11.5219 13.5007C9.32188 12.4601 7.54063 10.6788 6.5 8.47883L8.04063 7.21945C8.46875 6.86945 8.61562 6.28195 8.40312 5.77258L7.15312 2.77258V2.76945Z",
      fill: "#A1A1A1"
    }, null, -1)
  ])))
}
export default { render: render }